function scrollToSmooth(elementSelector) {
    document.querySelector(elementSelector).scrollIntoView({ 
        behavior: 'smooth' 
    });
}
